import React, { Component } from 'react';

import DateDropDown from '../../operations/common/datedropdown';
import { AmountStatusDropdown } from '../../operations/common/dropdowns';
import RefreshButton from '../../common/refreshbutton';
import DownloadPayrollCSVButton from './DownloadPayrollCSVButton';
import ClientSearch from '../../operations/common/clientsearch';
import history from '../../../history';
import SearchBar from '../../operations/common/SearchBar';
import { SelectRole } from '../../common/SelectRole';
import { TPageNotification } from '../../../types';
import { GenerateTimesheetModal } from './GenerateTimesheetModal';
import ActionButton from '../../common/ActionButton';
import { TGenerateTimesheetPayload, TSelectedBookingSummary } from './types';

interface PayrollFiltersProps {
    onFilterChange: (id: string, value: any) => void;
    history: any;
    reloadData: () => void;
    notification: TPageNotification;
    isGenerateEnabled?: boolean;
    selectedBookings?: TSelectedBookingSummary[];
    onGenerateTimesheet: (payload: TGenerateTimesheetPayload) => Promise<void>;
}

interface PayrollFiltersState {
    query: any;
    isGenerateModalOpen: boolean;
}

export default class PayrollFilters extends Component<PayrollFiltersProps, PayrollFiltersState> {
    state: PayrollFiltersState = {
        query: {},
        isGenerateModalOpen: false,
    };

    onFilterChange = (id: string, value: any) => {
        this.props.onFilterChange(id, value);
    };

    openGenerateModal = () => {
        this.setState({ isGenerateModalOpen: true });
    };

    closeGenerateModal = () => {
        this.setState({ isGenerateModalOpen: false });
    };

    componentDidUpdate(prevProps: PayrollFiltersProps) {
        if (
            this.state.isGenerateModalOpen &&
            prevProps.selectedBookings?.length &&
            !this.props.selectedBookings?.length
        ) {
            this.closeGenerateModal();
        }
    }

    handleGenerate = async(payload: TGenerateTimesheetPayload) => {
        await this.props.onGenerateTimesheet(payload);
    };

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        const { isGenerateModalOpen } = this.state;
        const { isGenerateEnabled, selectedBookings = [] } = this.props;

        return (
            <div className="table-filter-container payroll-filter-container">
                <DateDropDown
                    onFilterChange={this.onFilterChange as any}
                    history={history}
                    mode="payroll"
                />
                <SelectRole
                    onFilterChange={this.onFilterChange as any}
                    currentUrlParams={currentUrlParams}
                />
                <AmountStatusDropdown
                    onFilterChange={this.onFilterChange as any}
                />
                <ClientSearch history={history} />
                <SearchBar
                    customPlaceHolder="Cost centre number..."
                    filterKey="bookings_cost_centre"
                    onFilterChange={this.onFilterChange}
                    currentUrlParams={currentUrlParams}
                    inputType="number"
                    maxInputLength={3}
                />
                <div className="table-action-bar">
                    <RefreshButton reloadData={this.props.reloadData} />
                    <DownloadPayrollCSVButton
                        history={history}
                        endpoint="freelancers"
                        notification={this.props.notification}
                    />
                    <ActionButton
                        actionName="Generate Timesheet"
                        iconClass="icon-plus-symbol"
                        text="Generate Timesheet"
                        disabled={!isGenerateEnabled}
                        onAction={this.openGenerateModal}
                    />
                </div>
                <GenerateTimesheetModal
                    isOpen={isGenerateModalOpen}
                    onClose={this.closeGenerateModal}
                    onGenerate={this.handleGenerate}
                    bookings={selectedBookings}
                />
            </div>
        );
    }
}
